import controller from './HomepageController';
import template from './homepage.html';

const module = angular.module('websked.homepage', []);

const toLoad = [
  controller
];

toLoad.forEach(fn => fn(module));

function routes($stateProvider) {
  $stateProvider
    .state('home', {
      template,
      url: '/',
      controller: 'HomepageController',
      data: {
        pageTitle: {
          de: 'Hauptseite',
          en: 'Home',
          es: 'Página Principal',
          fr: 'Page Principale'
        }
      }
    });
}

module.config([
  '$stateProvider',
  routes
]);
